module.exports = __webpack_public_path__ + "static/img/start.0deb6a6b.png";